export const GETTERS_FILES_PROCESSING_LIST = "GETTERS_FILES_PROCESSING_LIST";
export const GETTERS_FILES_PROCESSING_PAGINATION =
  "GETTERS_FILES_PROCESSING_PAGINATION";
export const GETTERS_LATEST_ELIGIBILITY_FILE =
  "GETTERS_LATEST_ELIGIBILITY_FILE";
export const GETTERS_LATEST_BIOMETRIC_FILE = "GETTERS_LATEST_BIOMETRIC_FILE";
export const GETTERS_LATEST_INCENTIVE_FILE = "GETTERS_LATEST_INCENTIVE_FILE";
export const GETTERS_FILE_PROCESSING_UPLOAD_ERROR =
  "GETTERS_FILE_PROCESSING_UPLOAD_ERROR";

// action
export const ACTION_GET_FILES_PROCESSING_LIST =
  "ACTION_GET_FILES_PROCESSING_LIST";
export const ACTION_GET_LATEST_FILE = "ACTION_GET_LATEST_FILE";
export const ACTION_GET_FILE_PROCESSING_UPLOAD_ERROR =
  "ACTION_GET_FILE_PROCESSING_UPLOAD_ERROR";
export const ACTION_DOWNLOAD_FILE_UPLOAD = "ACTION_DOWNLOAD_FILE_UPLOAD";
export const ACTION_DOWNLOAD_ERROR_FILE_REVIEW =
  "ACTION_DOWNLOAD_ERROR_FILE_REVIEW";

// mutation
export const MUTATION_SET_FILES_PROCESSING_LIST =
  "MUTATION_SET_FILES_PROCESSING_LIST";
export const MUTATION_SET_LATEST_PROCESSING = "MUTATION_SET_LATEST_PROCESSING";
export const MUTATION_SET_FILE_PROCESSING_UPLOAD_ERROR =
  "MUTATION_SET_FILE_PROCESSING_UPLOAD_ERROR";



// WEBPACK FOOTER //
// ./src/store/modules/files_processing/constants.js